<template>
    <inline-loader v-if="head_loading"></inline-loader>

    <template v-else>
    <template v-if="condition.school_class_id">
        <page-title
            title="ふり返りシート確認（詳細）"
            icon="bi-bricks"
            :title_sub_1="is_muji ? '無地' : ''"
            :backTo="{name: is_muji ? 'PageRepocraftMujiWorksheetList' : 'PageRepocraftWorksheetList', params: {year: condition.year, grade: condition.grade, class: condition.school_class_id}}"
        >
        </page-title>

        <inline-loader v-if="loading"></inline-loader>

        <div class="d-flex" v-else>

            <div class="col-18">
                <summary-box title="対象">
                    <summary-box-row optional_title_class="col-5 col-lg-3" :text="Grade.getGradeValue(school_class.grade) + school_class.class_name_display + '（'+ school_class.year + '年度）'"></summary-box-row>
                    <summary-box-row optional_title_class="col-5 col-lg-3" :text="account_user_worksheet.planned_worksheet.subject.subject_name"></summary-box-row>
                    <summary-box-row title="ふり返り" optional_title_class="col-6 col-lg-4">
                        <!-- ワークSelectBox -->
                        <div class="col-24 col-md-17 col-lg-12 d-flex flex-grow-1 me-2">
                            <button-dom-show icon="bi-chevron-left" v-if="target_handout_index" @click="preWorksheet"></button-dom-show>
                            <div v-else class="btn-null"></div>
                            <div class="col-12 ms-2">
                                <form-select
                                    v-model="route.planned_worksheet_id"
                                    :options="option_worksheets"
                                    @change="goWorksheet"
                                ></form-select>
                            </div>
                            <button-dom-show v-if="target_handout_index + 1 !== handouts.length" @click="nextWorksheet" class="ms-2"></button-dom-show>
                            <div v-else class="btn-null ms-2"></div>
                        </div>
                    </summary-box-row>
                    <summary-box-row
                        :title="$student_label()"
                        optional_title_class="col-6 col-lg-4"
                    >
                        <!-- 児童SelectBox -->
                        <div class="col-24 col-md-17 col-lg-12 d-flex flex-grow-1 me-2">
                            <button-dom-show icon="bi-chevron-left" v-if="target_student_index" @click="preStudent"></button-dom-show>
                            <div v-else class="btn-null"></div>
                            <div class="col-12 ms-2">
                                <form-select
                                    v-model="route.account_user_id"
                                    option_key="account_user_id"
                                    option_label="student_name_display"
                                    :options="students"
                                    @change="goStudent"
                                ></form-select>
                            </div>
                            <button-dom-show class="ms-2" v-if="target_student_index + 1 !== students.length" @click="nextStudent"></button-dom-show>
                            <div v-else class="btn-null ms-2"></div>
                        </div>
                    </summary-box-row>
                </summary-box>

                <inline-loader v-if="loading_handouts"></inline-loader>

                <div class="col-22" v-else>
                    <section-title :title="'ふり返りシート' + (1 + target_handout_index) +': ' + account_user_worksheet.planned_worksheet.worksheet_name" class="flex-column flex-md-row"></section-title>

                    <div class="d-flex align-items-center">
                        <div class="me-3 col-9">
                            <!-- 配布日 -->
                            <summary-box-section title="配布日">
                                <summary-box-row :text="$helper.isNud(account_user_worksheet.student_worksheet.handout_date) ? '未配布' : $helper.ymd(account_user_worksheet.student_worksheet.deadline_date)"></summary-box-row>
                            </summary-box-section>
                        </div>
                        <div v-if="!$helper.isNud(account_user_worksheet.student_worksheet.handout_date)" class="col-9">
                            <!-- 締切日 -->
                            <summary-box-section
                                title="締切日"
                            >
                                <summary-box-row :text="$helper.ymd(account_user_worksheet.student_worksheet.deadline_date)"></summary-box-row>
                            </summary-box-section>
                        </div>
                        <div v-else class="col-9">
                            <form @submit.prevent="execHandout">
                                <button-exec-edit text="配布する" size="btn-md"></button-exec-edit>
                            </form>
                        </div>
                    </div>

                    <div class="d-flex flex-wrap align-items-center mt-2" v-if="!$helper.isNud(account_user_worksheet.student_worksheet.handout_date)">
                        <div class="me-3 col-9">
                            <!-- 提出状態 -->
                            <summary-box-section
                                title="提出状態"
                            >
                                <summary-box-row
                                    :text="account_user_worksheet.student_worksheet.submit_status_display"
                                ></summary-box-row>
                            </summary-box-section>
                        </div>

                        <template v-if="!$helper.isNud(account_user_worksheet.student_worksheet.handout_date)">
                            <div class="me-3 col-9" v-if="!$helper.isNud(account_user_worksheet.student_worksheet.submit_datetime)">
                                <!-- 提出日 -->
                                <summary-box-section
                                    title="提出日"
                                >
                                    <summary-box-row
                                        :text="$helper.ymd(account_user_worksheet.student_worksheet.submit_datetime)"
                                    ></summary-box-row>
                                </summary-box-section>
                            </div>
                            <div class="me-3 col-9"
                                v-if="
                                    account_user_worksheet.student_worksheet.submit_status === SubmitStatus.RESUBMIT
                                    || !$helper.isNud(account_user_worksheet.student_worksheet.resubmit_datetime)
                                "
                            >
                                <!-- 再提出日 -->
                                <summary-box-section
                                    title="再提出日"
                                >
                                    <summary-box-row
                                        :text="
                                            $helper.isNud(account_user_worksheet.student_worksheet.resubmit_datetime)
                                                ? '-'
                                                : $helper.ymd(account_user_worksheet.student_worksheet.resubmit_datetime)
                                            "
                                    ></summary-box-row>
                                </summary-box-section>
                            </div>
                        </template>
                    </div>
                    <div class="mt-5" v-if="!$helper.isNud(account_user_worksheet.student_worksheet.handout_date)">
                        <button-wrap>
                            <template v-slot:default>
                                <button-exec-edit
                                    v-if="account_user_worksheet.student_worksheet.submit_status === SubmitStatus.NOT_REQUIRED"
                                    size=""
                                    text="未提出にする"
                                    @click="updateStatusToPending"
                                ></button-exec-edit>
                                <button-exec-edit
                                    v-if="account_user_worksheet.student_worksheet.submit_status === SubmitStatus.PENDING ||
                                    account_user_worksheet.student_worksheet.submit_status === SubmitStatus.RESUBMIT"
                                    size=""
                                    text="提出済にする"
                                    @click="updateStatusToSubmitted"
                                ></button-exec-edit>
                                <button-exec-edit
                                    v-if="account_user_worksheet.student_worksheet.submit_status === SubmitStatus.SUBMITTED"
                                    size=""
                                    text="再提出にする"
                                    @click="updateStatusToResubmit"
                                ></button-exec-edit>
                                <button-exec-edit
                                    v-if="account_user_worksheet.student_worksheet.submit_status === SubmitStatus.PENDING ||
                                    account_user_worksheet.student_worksheet.submit_status === SubmitStatus.RESUBMIT"
                                    size=""
                                    text="提出不要にする"
                                    @click="updateStatusToNotRequired"
                                ></button-exec-edit>
                            </template>
                        </button-wrap>
                    </div>

                    <hr>

                    <!-- メイン部 -->
                    <div class="d-flex">
                        <div class="col-24 pe-2 pb-4">
                            <!-- 作品タイトル -->
                            <template
                                v-if="
                                    account_user_worksheet.planned_worksheet.subject.option_work_title === OptionWorkTitle.ENABLE
                                    && account_user_worksheet.student_worksheet.work_title
                                "
                            >
                                <div class="d-flex align-items-center mt-5">
                                    <summary-title-sub :title="is_muji ? `タイトル` : `作品タイトル`"></summary-title-sub>
                                    <p class="fw-bold">{{ account_user_worksheet.student_worksheet.work_title }}</p>
                                </div>
                            </template>

                            <!-- 作品画像 -->
                            <div class="work-photos d-flex flex-wrap align-items-center justify-content-around gap-1 mt-3" v-if="account_user_worksheet.student_worksheet.photos.length > 0">
                                <div class="work mb-3" v-for="(photo, index) in account_user_worksheet.student_worksheet.photos" :key="index">
                                    <img class="pointer" :src="photo.file.url" @click="openModal(photo.file)" alt="1">
                                </div>
                            </div>

                            <!-- 質問START -->
                            <template v-for="(question, index) in account_user_worksheet.planned_worksheet.questions" :key="index">
                                <div class="d-flex align-items-center mt-5">
                                    <summary-title-sub :title="'質問' + (index + 1)"></summary-title-sub>
                                    <p v-if="question.mapped_evaluation_item_type" class="title_category">{{ question.mapped_evaluation_item_type_display }}</p>
                                </div>
                                <h4 class="col text-primary fs-5 border-custom-dashed mx-2 mt-3"><strong class="small">{{ question.content }}</strong></h4>
                                <div class="row mt-4 mb-3">
                                    <div class="col-2"></div>
                                    <div class="col d-flex flex-column fs-5">
                                        <!-- question_type 選択肢 -->
                                        <template v-if="QuestionType.SELECT === question.question_type">
                                            <div v-for="(option, index) in student_question_answer_options(question.planned_question_id)" :key="index" class="d-flex flex-row">
                                                <template v-if="student_question_answer(question.planned_question_id) === option">
                                                    <p class="col-1"><i class="bi bi-check-lg text-success me-2"></i></p>
                                                    <p class="text-primary">{{ option }}</p>
                                                </template>
                                                <template v-else>
                                                    <p class="col-1 text-light"></p>
                                                    <p class="text-secondary">{{ option }}</p>
                                                </template>
                                            </div>
                                        </template>
                                        <!-- question_type 自由記入（必須回答・任意回答） -->
                                        <template v-else-if="
                                            QuestionType.INPUT_REQUIRED === question.question_type
                                            || QuestionType.INPUT_NULLABLE === question.question_type
                                        ">
                                            <p class="text-primary multiline">{{ student_question_answer_input(question.planned_question_id) }}</p>
                                        </template>
                                        <!-- question_type 画像 -->
                                        <template v-else-if="QuestionType.IMAGE === question.question_type">
                                            <!-- 画像 -->
                                            <div class="question-photos d-flex flex-wrap align-items-center justify-content-between gap-1 mt-3">
                                                <div class="work mb-3" v-for="(file) of student_question_answer_image_files(question.planned_question_id)" :key="file">
                                                    <img class="pointer" :src="file.url" @click="openModal(file)" alt="1">
                                                </div>
                                            </div>
                                        </template>
                                        <!-- question_type 顔アイコン2択 -->
                                        <template v-else-if="QuestionType.ICON_TWO === question.question_type">
                                            <p class="text-primary">
                                                <i class="bi fs-1" :class="IconTypeTwo.get(student_question_answer(question.planned_question_id))"></i>
                                            </p>
                                        </template>
                                        <!-- question_type 顔アイコン3択 -->
                                        <template v-else-if="QuestionType.ICON_THREE === question.question_type">
                                            <p class="text-primary">
                                                <i class="bi fs-1" :class="IconTypeThree.get(student_question_answer(question.planned_question_id))"></i>
                                            </p>
                                        </template>
                                    </div>
                                </div>
                            </template>

                            <div class="mt-3"></div>
                            <hr class="mt-5">

                            <div class="d-flex align-items-center mt-4">
                                <summary-title-sub :title="`${$student_label()}からのいいね数`"></summary-title-sub>
                                <p class="col fs-5 ms-2">
                                    <i class="bi bi-heart-fill text-danger me-2"></i>
                                    {{ account_user_worksheet.student_worksheet.like_count }}
                                </p>
                            </div>

                            <div class="d-flex align-items-center mt-4">
                                <summary-title-sub :title="`${$student_label()}からのコメント`"></summary-title-sub>
                                <p class="col fs-5 ms-2">
                                    <i class="bi bi-pencil-fill text-success me-2"></i>
                                    {{ account_user_worksheet.student_worksheet.comment_count }}
                                </p>
                            </div>
                            <div class="mt-2 mb-3"  v-if="account_user_worksheet.student_worksheet.comment_count">
                                <div class="comment" v-for="(comment, index) in account_user_worksheet.student_worksheet.comments" :key="index">
                                    <p>
                                        <i class="bi bi-person-fill"></i>
                                        {{ comment.account_user.student_name + 'さん' }}
                                    </p>
                                    <p class="multiline">{{ comment.content }}</p>
                                </div>
                            </div>

                            <hr>

                            <div class="mt-3">
                                <form-textarea
                                    v-model="account_user_worksheet.student_worksheet.teacher_comment"
                                    :placeholder="$student_label() + 'のふり返りシートへコメントを入力'"
                                ></form-textarea>
                            </div>
                            <div class="mt-4">
                                <button-wrap>
                                    <template v-slot:default>
                                        <button-exec-edit
                                            size=""
                                            text="コメント送信"
                                            @click="saveTeacherComment"
                                            :disabled="!account_user_worksheet.student_worksheet.teacher_comment || !account_user_worksheet.student_worksheet.teacher_comment.match(/\S/g)"
                                        ></button-exec-edit>
                                    </template>
                                </button-wrap>
                            </div>
                        </div>

                        <div v-if="!right_shown">
                            <!-- stickyボタン -->
                            <div class="sticky-md-top fix-right-button-open ms-3" @click="rightBoxOpen">
                                <div class="sticky-button-text">総合評価OPEN</div>
                                <i class="bi bi-arrow-down-left-square-fill fs-4"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 評価機能がONの場合のみ表示 -->
            <div class="col-7 box-right border border-primary ps-3 mb-1" v-if="isAbleToEvaluate">
                <!-- 総合評価カラム -->
                <inline-loader v-if="loading_evaluation" class="mt-3"></inline-loader>

                <template v-else >
                    <div class="w-100 row position-relative pb-5 pt-3 " v-if="right_shown">
                        <form @submit.prevent="saveEvaluation" class="pt-2">
                            <section-title-sub title="題材別 総合評価" class="pe-4"></section-title-sub>
                            <!-- 一旦はずす <div class="text-secondary text-end"><small>（計 ワーク）</small></div> -->

                            <!-- 各スコア -->
                            <template v-for="(evaluation_score, index) in evaluation_scores" :key="index">
                                <p class="title_category">
                                    {{ MappedEvaluationItemType.get(evaluation_score.evaluation_item_type) }}
                                </p>
                                <p class="col text-secondary multiline mt-2 ms-md-1">
                                    {{ evaluation_score.evaluation_item }}
                                </p>
                                <div class="d-flex justify-content-center text-center mt-2 ms-1 ms-md-2 mb-5">
                                    <div
                                        class="col-5 p-1 border border-dark cursor"
                                        style="transition: .5s linear;"
                                        :class="{'bg-secondary text-white': evaluation_score.evaluation_score >= 1}"
                                        @click="setScore(1, evaluation_score)"
                                    >
                                        1
                                    </div>
                                    <div
                                        class="col-5 p-1 border border-start-0 border-dark cursor"
                                        style="transition: .5s linear;"
                                        :class="{'bg-secondary text-white': evaluation_score.evaluation_score >= 2}"
                                        @click="setScore(2, evaluation_score)"
                                    >
                                        2
                                    </div>
                                    <div
                                        class="col-5 p-1 border border-start-0 border-dark cursor"
                                        style="transition: .5s linear;"
                                        :class="{'bg-secondary text-white': evaluation_score.evaluation_score >= 3}"
                                        @click="setScore(3, evaluation_score)"
                                    >
                                        3
                                    </div>
                                    <div
                                        class="col-5 p-1 border border-start-0 border-dark cursor"
                                        style="transition: .5s linear;"
                                        :class="{'bg-secondary text-white': evaluation_score.evaluation_score >= 4}"
                                        @click="setScore(4, evaluation_score)"
                                    >
                                        4
                                    </div>
                                    <div
                                        class="col-5 p-1 border border-start-0 border-dark cursor"
                                        style="transition: .5s linear;"
                                        :class="{'bg-secondary text-white': evaluation_score.evaluation_score === 5}"
                                        @click="setScore(5, evaluation_score)"
                                    >
                                        5
                                    </div>
                                </div>
                            </template>

                            <hr class="mt-5">

                            <summary-title-sub title="総観・メモ" class="mt-3"></summary-title-sub>
                            <div class="text-secondary text-end"><small>※ 表示なし</small></div>
                            <textarea class="form-control ms-md-1" v-model="teacher_note"></textarea>

                            <button-wrap optional_class="mt-5 mb-5">
                                <template v-slot:default>
                                    <button-exec-edit></button-exec-edit>
                                </template>
                            </button-wrap>
                        </form>
                    </div>
                </template>
            </div>
        </div>
    </template>
    </template>

    <!-- 画像モーダル -->
    <div v-if="modal_shown">
        <transition name="fade">
            <div class="modal_inner">
                <div class="modal-backdrop show"></div>
                <div class="modal" tabindex="-1" style="display:block">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <!-- modal head -->
                            <div class="modal-header">
                                <h4 class="modal-title">{{ is_muji ? `写真` : `作品` }}</h4>
                                <button type="button" class="btn-close" @click="closeModal"></button>
                            </div>
                            <!-- modal body -->
                            <div class="modal-body">
                                <div>
                                    <div class="row">
                                        <div class="col-24 d-flex align-items-center justify-content-center">
                                            <img :src="modal_file.url" class="mw-100 mh-100">
                                        </div>
                                    </div>

                                    <button-wrap optional_class="mt-5 mb-5">
                                        <template v-slot:default>
                                            <button-dom-close @click="closeModal"></button-dom-close>
                                        </template>
                                    </button-wrap>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
import AccountUser from '@/shared/models/entities/account-user';
import AccountUserWorksheet from '@/shared/models/entities/repocraft/account-user-worksheet';
import Handout from '@/shared/models/entities/repocraft/handout';
import SchoolClass from '@/shared/models/entities/school-class';
import Grade from '@/shared/models/enums/grade';
import IconTypeTwo from '@/shared/models/enums/icon-type-two';
import IconTypeThree from '@/shared/models/enums/icon-type-three';
import MappedEvaluationItemType from '@/shared/models/enums/mapped-evaluation-item-type';
import OptionWorkTitle from "@/shared/models/enums/option-work-title";
import QuestionType from '@/shared/models/enums/question-type';
import RepocraftEvaluation from '@/shared/models/enums/repocraft-evaluation';
import SubmitStatus from '@/shared/models/enums/submit-status';
import PageTitle from '@/shared/components/design/PageTitle';
import SectionTitle from '@/shared/components/design/SectionTitle';
import SectionTitleSub from '@/shared/components/design/SectionTitleSub';
import SummaryBox from '@/shared/components/design/SummaryBox';
import SummaryBoxRow from '@/shared/components/design/SummaryBoxRow';
import SummaryBoxSection from '@/shared/components/design/SummaryBoxSection';
import SummaryTitleSub from '@/shared/components/design/SummaryTitleSub';
import ButtonWrap from '@/shared/components/design/buttons/ButtonWrap';
import ButtonDomShow from '@/shared/components/design/buttons/ButtonDomShow';
import ButtonExecEdit from '@/shared/components/design/buttons/ButtonExecEdit';
import ButtonDomClose from '@/shared/components/design/buttons/ButtonDomClose';
import FormSelect from '@/shared/components/form/FormSelect';
import FormTextarea from '@/shared/components/form/FormTextarea';
import InlineLoader from '@/shared/components/tool/InlineLoader';

export default {
    name: 'PageRepocraftWorksheetStudent',
    components: {
        PageTitle,
        SectionTitle,
        SectionTitleSub,
        SummaryBox,
        SummaryBoxRow,
        SummaryBoxSection,
        SummaryTitleSub,
        ButtonWrap,
        ButtonDomShow,
        ButtonExecEdit,
        ButtonDomClose,
        FormSelect,
        FormTextarea,
        InlineLoader
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            is_muji: this.$route.meta?.is_muji ?? false, // レポクラフト無地判定
            app_key: this.$route.meta?.is_muji ? 'repocraft_muji' : 'repocraft', //アプリ名取得

            condition: {
                year: null,
                grade: null,
                school_class_id: null,
            },

            school_class: new SchoolClass(),
            account_user_worksheet: new AccountUserWorksheet(),
            students: [],
            handouts: [],

            evaluation_scores: [],
            teacher_note: null,
            feedback_comment: null,


            route: {
                account_user_id: Number(this.$route.params.account_user),
                planned_worksheet_id: Number(this.$route.params.worksheet),
            },

            target_account_user: {},
            target_student_index: null,
            target_handout_index: null,

            //選択肢
            option_worksheets: [],

            //enum
            Grade,
            IconTypeTwo,
            IconTypeThree,
            MappedEvaluationItemType,
            QuestionType,
            SubmitStatus,
            OptionWorkTitle,
            RepocraftEvaluation,

            //loading
            head_loading: true,
            loading: 0,
            loading_handouts: true,
            loading_evaluation: true,

            //right_box
            right_shown: true,

            modal_file: null,
            modal_shown: false,
        }
    },
    mounted() {
        this.getStudent();
    },
    //パラメータのみ違うリンクへのroutingの場合
    beforeRouteUpdate (to, from, next) {
        //遷移前アクション
        next();
        //遷移後アクション
        this.route.planned_worksheet_id = Number(to.params.worksheet);
        this.route.account_user_id = Number(to.params.account_user);
        this.getStudentWorksheet();
    },
    methods: {
        //１児童情報取得
        getStudent() {
            this.head_loading = true;
            this.loading++;
            this.$http.get(`/school/${this.app_key}/account_user/${Number(this.route.account_user_id)}`)
            .then(response => {
                //空の場合
                if (this.$helper.isNud(response.data) || 0 === response.data.length) {
                    this.showErrorMessage(`存在しない${this.$student_label()}です`);
                    this.$router.push({name: this.is_muji ? 'PageRepocraftMujiHome' : 'PageRepocraftHome'});
                    return;
                }
                // 児童セット
                this.target_account_user = new AccountUser(response.data);

                // 学年・クラスをセット
                this.condition.year = this.target_account_user.year;
                this.condition.grade = this.target_account_user.grade;

                //クラスIDセット
                if (this.$helper.isNud(this.target_account_user.school_class.school_class_id)) {
                    this.showErrorMessage('クラス情報が取得できません、あるいはクラスが存在しません');
                    this.$router.push({name: this.is_muji ? 'PageRepocraftMujiHome' : 'PageRepocraftHome'});
                    return;
                }
                this.condition.school_class_id = this.target_account_user.school_class.school_class_id;
                this.head_loading = false;
            })
            .catch(() => {
                //エラーリダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiHome' : 'PageRepocraftHome'});
                return;
            })
            .finally(() => {
                this.getStudentWorksheet();
                this.head_loading = false;
                this.loading--;
            });
        },

        //１児童のワークシート取得
        getStudentWorksheet() {
            this.loading++;
            //１児童の提出状況および提出内容の取得
            this.$http.get(`/school/${this.app_key}/planned_worksheet/${Number(this.route.planned_worksheet_id)}/account_user/${Number(this.route.account_user_id)}/student_worksheet`)
            .then(response => {
                //空の場合
                if (this.$helper.isNud(response.data) || 0 === response.data.length) {
                    this.showErrorMessage(`存在しない${this.$student_label()}もしくは存在しないワークシートです`);
                    this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetList' : 'PageRepocraftWorksheetList', params: {year: this.condition.year, grade: this.condition.grade, class: this.condition.school_class_id}});
                    return;
                }

                // 児童ワークシートセット
                this.account_user_worksheet = new AccountUserWorksheet(response.data);

                this.getSchoolClass();
                this.getStudentList();
                this.getHandoutList();
                this.getStudentEvaluation();
            })
            .catch(() => {
                //エラーリダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetList' : 'PageRepocraftWorksheetList', params: {year: this.condition.year, grade: this.condition.grade, class: this.condition.school_class_id}});
                return;
            })
            .finally(() => {
                this.loading--;
            });
        },

        //特定クラス情報取得（兼用）
        getSchoolClass() {
            this.loading++;
            this.$http.get(`/school/${this.app_key}/year/${this.condition.year}/grade/${this.condition.grade}/class/${this.condition.school_class_id}`)
            .then(response => {
                this.school_class = new SchoolClass(response.data);
            })
            .catch(() => {
                //エラーリダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetList' : 'PageRepocraftWorksheetList', params: {year: this.condition.year, grade: this.condition.grade, class: this.condition.school_class_id}});
                return;
            })
            .finally(() => {
                this.loading--;
            });
        },

        //選択肢用 現在の児童一覧取得
        getStudentList() {
            this.loading++;
            this.students = [];
            this.$http.get(`/school/${this.app_key}/year/${this.condition.year}/grade/${this.condition.grade}/class/${this.condition.school_class_id}/account_user`)
            .then(response => {
                for (let student of response.data) {
                    this.students.push(new AccountUser(student));
                }

                //現在の児童のindexをセット
                this.target_student_index = this.students.findIndex(((s) => s.account_user_id === this.route.account_user_id));
            })
            .catch(() => {
                //エラーリダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetList' : 'PageRepocraftWorksheetList', params: {year: this.condition.year, grade: this.condition.grade, class: this.condition.school_class_id}});
                return;
            })
            .finally(() => {
                this.loading--;
            });
        },

        //選択肢用 クラス配布済ワークシート一覧取得
        getHandoutList () {
            this.loading++;
            if (this.$helper.isNud(this.account_user_worksheet.planned_worksheet.subject.planned_subject_id)) {
                this.showErrorMessage('存在しないワークシートです');
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetList' : 'PageRepocraftWorksheetList', params: {year: this.condition.year, grade: this.condition.grade, class: this.condition.school_class_id}});
                return;
            }

            this.option_worksheets = [];
            this.handouts = [];
            this.$http.get(`/school/${this.app_key}/year/${this.condition.year}/grade/${this.condition.grade}/subject/${this.account_user_worksheet.planned_worksheet.subject.planned_subject_id}/class/${this.condition.school_class_id}/handout`)
            .then(response => {
                for (let handout of response.data) {
                    //選択肢生成
                    this.option_worksheets.push({
                        key: handout.planned_worksheet.planned_worksheet_id,
                        label: handout.planned_worksheet.worksheet_name
                    });

                    //handoutsセット 配布実行時に利用
                    this.handouts.push(new Handout(handout));
                    //配布トランのうち、現在のhandoutのindexをセット
                    this.target_handout_index = this.handouts.findIndex(((h) => h.planned_worksheet.planned_worksheet_id === this.route.planned_worksheet_id));
                }
                //handoutsにパスパラメータのworksheet_idが紐づくものがなければエラーでリダイレクト
                let handout = this.handouts.find((h) => h.planned_worksheet.planned_worksheet_id === this.route.planned_worksheet_id);
                if (!handout || 0 === handout.length) {
                    this.showErrorMessage('まだクラス配布されていないワークシートです');
                    this.$router.push({name: this.is_muji ? 'PageRepocraftMujiSubjectEvaluation' : 'PageRepocraftSubjectEvaluation', params: {year: this.condition.year, grade: this.condition.grade, class: this.condition.school_class_id}, query: {subject: this.account_user_worksheet.planned_worksheet.subject.planned_subject_id}});
                    return;
                }
            })
            .catch(() => {
                //エラーリダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetList' : 'PageRepocraftWorksheetList', params: {year: this.condition.year, grade: this.condition.grade, class: this.condition.school_class_id}});
                return;
            })
            .finally(() => {
                this.loading--;
                this.loading_handouts = false;
            });
        },

        //児童の題材評価取得
        getStudentEvaluation() {
            this.$http.get(`/school/${this.app_key}/evaluation/subject/${this.account_user_worksheet.planned_worksheet.subject.planned_subject_id}/account_user/${Number(this.route.account_user_id)}`)
            .then(response => {
                this.evaluation_scores = response.data.evaluation_scores;
                this.teacher_note = response.data.teacher_note;
                this.feedback_comment = response.data.feedback_comment;
            })
            .catch(() => {
            })
            .finally(() => {
                this.loading_evaluation = false;
            });
        },

        setScore(score_range, score) {
            score.evaluation_score = score_range;
        },

        //配布実行
        execHandout() {
            this.startScreenLoading();

            //配布IDを取得
            let handout = this.handouts.find((h) => h.planned_worksheet.planned_worksheet_id === this.route.planned_worksheet_id);

            if (!Object.keys(handout).length) {
                this.showErrorMessage('まだクラス中に配布されていません');
                this.endScreenLoading();
                return;
            }

            this.$http.post(`/school/${this.app_key}/student_worksheet`, {
                account_user_id: this.route.account_user_id,
                planned_worksheet_id: this.route.planned_worksheet_id,
                handout_id: handout.handout_id,
                deadline_date: this.$helper.ymd(this.$helper.today()), //現在日を登録
            })
            .then(() => {
                this.showMessage(this.message);
                this.getStudentWorksheet();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },

        //ステータスを「未提出」に変更
        updateStatusToPending() {
            this.startScreenLoading();

            if (this.account_user_worksheet.student_worksheet.submit_status !== SubmitStatus.NOT_REQUIRED) {
                this.showErrorMessage('未提出に変更できません');
                this.endScreenLoading();
                return;
            }

            this.$http.put(`/school/${this.app_key}/student_worksheet/${this.account_user_worksheet.student_worksheet.student_worksheet_id}/pending`)
            .then(() => {
                this.showMessage(this.message);
                this.getStudentWorksheet();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        //ステータスを「提出済」に変更
        updateStatusToSubmitted() {
            this.startScreenLoading();

            if (
                this.account_user_worksheet.student_worksheet.submit_status === SubmitStatus.SUBMITTED ||
                this.account_user_worksheet.student_worksheet.submit_status === SubmitStatus.NOT_REQUIRED
            ) {
                this.showErrorMessage('提出済みに変更できません');
                this.endScreenLoading();
                return;
            }

            this.$http.put(`/school/${this.app_key}/student_worksheet/${this.account_user_worksheet.student_worksheet.student_worksheet_id}/submit`)
            .then(() => {
                this.showMessage(this.message);
                this.getStudentWorksheet();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        //ステータスを「再提出」に変更
        updateStatusToResubmit() {
            this.startScreenLoading();

            if (this.account_user_worksheet.student_worksheet.submit_status !== SubmitStatus.SUBMITTED) {
                this.showErrorMessage('再提出に変更できません');
                this.endScreenLoading();
                return;
            }

            this.loading_handouts = true;
            this.$http.put(`/school/${this.app_key}/student_worksheet/${this.account_user_worksheet.student_worksheet.student_worksheet_id}/resubmit`)
            .then(() => {
                this.showMessage(this.message);
                this.getStudentWorksheet();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        //ステータスを「提出不要」に変更
        updateStatusToNotRequired() {
            this.startScreenLoading();

            if (
                this.account_user_worksheet.student_worksheet.submit_status === SubmitStatus.SUBMITTED ||
                this.account_user_worksheet.student_worksheet.submit_status === SubmitStatus.NOT_REQUIRED
            ) {
                this.showErrorMessage('提出不要に変更できません');
                this.endScreenLoading();
                return;
            }

            this.$http.put(`/school/${this.app_key}/student_worksheet/${this.account_user_worksheet.student_worksheet.student_worksheet_id}/not-required`)
            .then(() => {
                this.showMessage(this.message);
                this.getStudentWorksheet();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },

        //先生からのコメント保存
        saveTeacherComment() {
            this.startScreenLoading();

            this.$http.put(`/school/${this.app_key}/student_worksheet/${this.account_user_worksheet.student_worksheet.student_worksheet_id}/teacher-comment`,{
                teacher_comment: this.account_user_worksheet.student_worksheet.teacher_comment,
            })
            .then(() => {
                this.showMessage('コメントを保存しました');
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },

        //題材別評価保存
        saveEvaluation() {
            this.loading_evaluation = true;
            this.$http.put(`/school/${this.app_key}/evaluation/subject/${this.account_user_worksheet.planned_worksheet.subject.planned_subject_id}/account_user/${this.route.account_user_id}`,{
                evaluation_scores: this.evaluation_scores,
                teacher_note: this.teacher_note,
            })
            .then(() => {
                this.showMessage(this.message);
            })
            .finally(() => {
                this.loading_evaluation = false;
            });
        },

        //作品画像モーダルオープン
        openModal(file) {
            this.modal_file = file;
            if (!this.$helper.isNud(file.url)) {
                this.modal_shown = true;
            }
        },
        //作品画像モーダル閉じる
        closeModal() {
            this.modal_shown = false;
        },

        //評価Box（右側）OPEN
        rightBoxOpen() {
            this.right_shown = true;
        },
        //評価Box（右側）CLOSE
        rightBoxClose() {
            this.right_shown = false;
        },

        //ワークシートをSELECT
        goWorksheet() {
            if (!this.$helper.isNud(this.route.planned_worksheet_id)) {
                //リダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetStudent' : 'PageRepocraftWorksheetStudent', params: {worksheet: this.route.planned_worksheet_id, account_user: this.route.account_user_id}});
                return;
            }
        },
        //前のワークシートへ
        preWorksheet() {
            let pre_handout = this.handouts[this.target_handout_index - 1];
            if (!this.$helper.isNud(pre_handout) && Object.keys(pre_handout).length) {
                //リダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetStudent' : 'PageRepocraftWorksheetStudent', params: {worksheet: pre_handout.planned_worksheet.planned_worksheet_id, account_user: this.route.account_user_id}});
                return;
            }
        },
        //次のワークシートへ（配布済のみ）
        nextWorksheet() {
            let next_handout = this.handouts[this.target_handout_index + 1];
            if (!this.$helper.isNud(next_handout) && Object.keys(next_handout).length) {
                //リダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetStudent' : 'PageRepocraftWorksheetStudent', params: {worksheet: next_handout.planned_worksheet.planned_worksheet_id, account_user: this.route.account_user_id}});
                return;
            }
        },
        //児童をSELECT
        goStudent() {
            if (!this.$helper.isNud(this.route.account_user_id)) {
                //リダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetStudent' : 'PageRepocraftWorksheetStudent', params: {worksheet: this.route.planned_worksheet_id, account_user: this.route.account_user_id}});
                return;
            }
        },
        //前の児童へ
        preStudent() {
            let pre_student = this.students[this.target_student_index - 1];
            if (!this.$helper.isNud(pre_student) && Object.keys(pre_student).length) {
                //リダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetStudent' : 'PageRepocraftWorksheetStudent', params: {worksheet: this.route.planned_worksheet_id, account_user: pre_student.account_user_id}});
                return;
            }
        },
        //次の児童へ
        nextStudent() {
            let next_student = this.students[this.target_student_index + 1];
            if (!this.$helper.isNud(next_student) && Object.keys(next_student).length) {
                //リダイレクト
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiWorksheetStudent' : 'PageRepocraftWorksheetStudent', params: {worksheet: this.route.planned_worksheet_id, account_user: next_student.account_user_id}});
                return;
            }
        },
    },
    computed: {
        isAbleToEvaluate() {
            if (
                false === this.$helper.isNud(this.$store.state.school)
                && this.$store.state.school.auth.school.repocraft_evaluation === RepocraftEvaluation.ON
                && this.account_user_worksheet.planned_worksheet.subject.has_any_evaluation
            ) {
                return true;
            }

            return false;
        },
        //各行の質問トランを動的に取得
        student_question_answer: () => {
            return function (planned_question_id) {
                let student_question = this.account_user_worksheet.student_worksheet.questions.find((q) => q.planned_question_id === planned_question_id);
                if (typeof student_question === 'undefined') {
                    return '';
                } else {
                    return student_question.answer;
                }
            }
        },
        student_question_answer_options: () => {
            return function (planned_question_id) {
                let planned_question = this.account_user_worksheet.planned_worksheet.questions.find((q) => q.planned_question_id === planned_question_id);
                if (typeof planned_question === 'undefined') {
                    return '';
                } else {
                    return planned_question.options;
                }
            }
        },
        student_question_answer_input: () => {
            return function (planned_question_id) {
                let student_question = this.account_user_worksheet.student_worksheet.questions.find((q) => q.planned_question_id === planned_question_id);
                if (typeof student_question === 'undefined') {
                    return '';
                } else {
                    return student_question.answer;
                }
            }
        },
        student_question_answer_image_files: () => {
            return function (planned_question_id) {
                let student_question = this.account_user_worksheet.student_worksheet.questions.find((q) => q.planned_question_id === planned_question_id);
                if (typeof student_question === 'undefined') {
                    return '';
                } else {
                    return student_question.answer_files;
                }
            }
        },
    }
}
</script>

<style scoped>
    p {margin-bottom: 0;}
    .btn-null {width: 42px;}
    .comment {font-size: .95rem; display: flex; flex-wrap: nowrap; align-items: flex-start; gap: 1rem 0.5rem; margin: 0 0 1rem 7%; line-height: 1;}
    .comment p:first-child {flex-basis: 20%; text-align: center; color: #198754; font-size: .85rem;}
    .comment p:nth-child(2) {flex-basis: 80%;}
    .comment i {display: block; border: 1px solid #198754; border-radius: 50%; width: 35px; height: 35px; line-height: 35px; margin: 0 auto; font-size: 1.3rem; text-align: center; margin-bottom: .3rem;}
    .title_category {display: inline-block; padding: .2rem .5rem; border: 1px solid #198753; font-size: .8rem; text-align: center; color: #198753;}
    .work {text-align: center;}
    .work-photos { padding: 1rem .3rem 0; border: 1px dotted rgb(207 207 207); border-radius: 5px; }
    .work-photos::after{ content:""; display: block; width:45.8%; }
    .work-photos .work {max-width: 49%;}
    .question-photos::after{ content:""; display: block; width:30%; }
    .question-photos .work {max-width: 32%;}
    .work img {max-width: 100%; max-height: 350px;}
    .pointer:hover {cursor: pointer;}
    .border-custom-dashed {border-bottom: 1px dashed rgb(0 0 0 / 30%);}
    .box-right {background-color: #fff; margin-top: -1rem; position: fixed; right: 0.5rem; overflow: overlay; height: 80vh;}

    @media (min-width: 576px) {
        .main-shrink {
            width: calc( 98% - 8.33333333333% + (100vw - 540px) / 2 );
        }
        .box-right {
            margin-left: calc( -8.33333333333% + (100vw - 540px) / 2 );
        }
    }
    @media (min-width: 768px) {
        .main-shrink {
            width: calc( 98% - 8.33333333333% + (100vw - 720px) / 2 );
        }
        .box-right {
            margin-left: calc( -8.33333333333% + (100vw - 720px) / 2 );
        }
    }
    @media (min-width: 992px) {
        .main-shrink {
            width: calc( 98% - 8.33333333333% + (100vw - 960px) / 2 );
        }
        .box-right {
            margin-left: calc( -8.33333333333% + (100vw - 960px) / 2 );
        }
    }
    @media (min-width: 1200px) {
        .main-shrink {
            width: calc( 98% - 8.33333333333% + (100vw - 1140px) / 2 );
        }
        .box-right {
            margin-left: calc( -8.33333333333% + (100vw - 1140px) / 2 );
        }
    }
</style>

<style>
    .title-sub-1 {border-color: #198754 !important;}
</style>